export const sclTitles =  {
    managements:{
        informacionGeneral:{
            id_cliente:'ID Cliente',
            rfc:'Tipo gestión',
            gerencia:'Gerencia',
            id_grupo:'ID Grupo',
            nombre_grupo:'Nombre Grupo',
            producto:'Producto',
            rmd:'RMD',
            territorio:'Territorio',
            zona:'Zona',
            despacho:'Despacho'
        },
        pago:{
            id_cliente:'ID Cliente',
            prodcuto:'Producto',
            atraso_max:'Atraso Max',
            saldo:'Saldo',
            total:'Total',
            fecha_ultimo_pago:'Fecha Ultimo Pago',
            importe_pago_ultimo:'Importe Pago Ultimo',
            campania:'Campaña',
            fecha_asignacion:'Fecha Asignación',
            dias_asignacion:'Días Asignación'
        },
        direccion:{
            id_cliente:'ID Cliente',
            direccion:'Dirección',
            num_ext:'Num. Ext.',
            codigoPostal:'CP',
            colonia:'Colonia',
            poblacion:'Población',
            estado:'Estado'
        },
        telefonos:{
            id_cliente:'ID Cliente',
            telefono1:'Telefono1',
            telefono2:'Telefono2',
            telefono3:'Telefono3'
        }
    },
    bitacora:{
        
    },
    calendar:{

    },
    carruselNoticias:{
        
    },
    database:{

    },
    documents:{

    },
    graficasEstaticas:{

    },
    grupos:{

    },
    minutas:{

    },
    notices:{

    },
    projectTracking:{

    },
    reports:{

    },
    userManagement:{

    },
    workplaces:{

    }
}